import { Inject, Injectable, Optional } from '@angular/core';
import { RESPONSE } from 'lib/tokens.js';
import { ServerResponse } from 'http';

type StatusCode = 404 | 200;

@Injectable({
	providedIn: 'root'
})
export class ResponseService {
	constructor(@Optional() @Inject(RESPONSE) private serverResponse: ServerResponse | null) {}

	/**
	 * This only works in production build. The Vite server currently does not support injecting respose / request tokens
	 */
	setStatusCode(statusCode: StatusCode): void {
		if (this.serverResponse) {
			this.serverResponse.statusCode = statusCode;
		}
	}
}
